"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { guideConceptNumber } from "@/content/guide-content";
import type { GuideSection } from "@/content/guide-schema";
import { GuideContentImage } from "./GuideContentImage";
import { GuideMarkdown } from "./GuideMarkdown";

export function GuideHowItWorks({ sections }: { sections: GuideSection[] }) {
  return (
    <Accordion
      type="single"
      collapsible
      defaultValue={sections[0]?.id}
      className="grid gap-4"
    >
      {sections.map((section, index) => (
        <AccordionItem
          key={section.id}
          value={section.id}
          data-testid="system-how-section"
          className="rounded-2xl border bg-card px-5 last:border-b"
        >
          <AccordionTrigger className="cursor-pointer gap-4 py-5 hover:no-underline">
            <span className="flex min-w-0 items-center gap-4">
              <span className="grid size-9 shrink-0 place-items-center rounded-xl bg-primary/10 font-semibold text-primary text-sm">
                {guideConceptNumber(index)}
              </span>
              <span className="text-left font-heading font-bold text-lg">
                {section.title}
              </span>
            </span>
          </AccordionTrigger>
          <AccordionContent className="pb-5">
            {section.image ? (
              <GuideContentImage image={section.image} className="mb-5" />
            ) : null}
            <GuideMarkdown
              className="pl-13 text-sm leading-7"
              markdown={section.markdown}
            />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
